import { useField } from 'formik';
import moment from 'moment';
import DatePicker from 'components/DatePicker';
import { IDatePickerField } from './types';
import { useCallback, useState, useEffect } from 'react';

const DatePickerField = ({ name, saveFormat, ...rest }: IDatePickerField) => {
  const [{ value }, { error, touched }, { setTouched, setValue }] = useField(name);
  const [shouldBeTouched, setShouldBeTouched] = useState(false);

  const date = value ? moment.utc(value) : null;

  const onChange = (date) => {
    setValue(date && (saveFormat ? date.format(saveFormat) : date.utc().toISOString()), true);
  };

  const onClose = useCallback(() => {
    if (!touched) {
      setShouldBeTouched(true);
    }
  }, [touched]);

  useEffect(() => {
    if (!touched && shouldBeTouched) {
      setTouched(true, true);
    }
  }, [setTouched, shouldBeTouched, touched]);

  return (
    <DatePicker
      name={name}
      value={date}
      error={Boolean(error && touched)}
      helperText={Boolean(error && touched) && error}
      onClose={onClose}
      {...rest}
      onChange={onChange}
    />
  );
};

export default DatePickerField;
